import React from 'react';
import _ from 'lodash';
import {connect} from "react-redux";

import Grid from '@material-ui/core/Grid';

import { isSectionVisible, withEuroOrDash, withPercentOrDash } from '../../../utils/utils';
import ReturnValue from './components/ReturnValue';

import useAggregatedReturnSectionStyles from './styles';
import {getSharedSettingsWarning} from "../../../containers/CustomerDashboardV2/utils";
import WarningTooltip from "../../WarningTooltip";
import {getSharedSettingsSelector} from "../../../utils/redaxSelectors";

const mapStateToProps = (state) => ({
  sharedSettings: getSharedSettingsSelector(state),
});

const AggregatedPortfolioReturnSection = ({data, dataKey, customSettings, reportType, sharedSettings}) => {

  const classes = useAggregatedReturnSectionStyles();

  if (!data) return null;

  const values = _.get(data, `data.${dataKey}`) || {};
  const pa_warning = getSharedSettingsWarning(_.get(values, 'percentage_pa_warning'), sharedSettings.data);

  return (
    <Grid container spacing={4}>
      {isSectionVisible(customSettings, 'profit_perc', reportType) && (
        <Grid item className={classes.wrapper}>
          <span className={classes.title}>GuV (%)</span>
          <span className={classes.value}>
            <ReturnValue value={values.percentage} valueHandler={withPercentOrDash} />
          </span>
        </Grid>
      )}
      {isSectionVisible(customSettings, 'profit_amount', reportType) && (
        <Grid item className={classes.wrapper}>
          <span className={classes.title}>GuV (€)</span>
          <span className={classes.value}>
            <ReturnValue value={values.value} valueHandler={withEuroOrDash}/>
          </span>
        </Grid>
      )}
      {isSectionVisible(customSettings, 'profit_pa', reportType) && (
        <Grid item className={classes.wrapper}>
          <span className={classes.title}>GuV p.a. (%)</span>
          <span className={classes.value}>
            {!!pa_warning
              ? <>- <WarningTooltip title={pa_warning}/></>
              : <ReturnValue value={values.percentage_pa} valueHandler={withPercentOrDash}/>}
          </span>
        </Grid>
      )}
    </Grid>
  )
};

export default connect(mapStateToProps)(AggregatedPortfolioReturnSection);